module.exports = __webpack_public_path__ + "static/navybooties-98b85319a1bb0d52b95e59b4acddeb37.png";